/* eslint-disable no-unused-vars */
const devApiDomain = 'https://europe-dev.dankal.cn/v1/' // 开发环境api域名
const devExportApi = 'https://europe-dev.dankal.cn/' // 开发环境导出表格api域名
const stageApiDomain = '' // 测试环境api域名
const proApiDomain = 'https://storesite-pro.idalhome.com/v1/' // 生产环境api域名
const proExportApi = 'https://storesite-pro.idalhome.com/' // 生产环境导出表格api域名
const devImgDomain = 'https://cdn.idalhome.com/' // 开发环境图片域名
const proImgDomain = '' // 生产环境图片域名

export const apiDomain = proApiDomain;

export const exportApi = proExportApi;


export const imgDomain = devImgDomain;

export const uploadDomain = 'https://upload-na0.qiniup.com/';



// WEBPACK FOOTER //
// ./src/configs/env.js